export const TREE_COLUMN_DESC = 'This column shows the dependency tree from projects<br>down to individual modules and submodules.';

export const DEPENDENCIES_COLUMN_DESC = 'This column shows the number of dependencies of a project or module.';

export const ERROR_COLUMN_DESC = 'This columns shows the number of CVEs with a CVSS score of a project or module.';

export const WARNING_COLUMN_DESC = 'This column shows the number of CVEs without a CVSS score of a project or module.';

export const MIN_CVSS_COLUMN_DESC = 'This column shows the lowest CVSS of a project or module.';

export const MAX_CVSS_COLUMN_DESC = 'This column shows the highest CVSS of a project or module.';

export const CVSS_COLUMN_DESC = 'This columns show the CVSS scores of a project or module.';

export const TOP_BUGS_DESC = 'These columns show the top bugs.<br>It is configurable by clicking the gear icon.';

export const METAINFO_DESC = 'These columns show addtional LGTM and GitHub.';

export const SEARCH_FIELD_DESC = 'Search a specific repository, library or bug.';

export const NUM_DEPENDENCIES_SLIDER_DESC = 'Filter items by the number of dependencies.';

export const NUM_ERRORS_SLIDER_DESC = 'Filter items by the number of errors.';

export const MIN_CVSS_SLIDER_DESC = 'Filter items by the minimum CVSS score.';

export const MAX_CVSS_SLIDER_DESC = 'Filter items by the maximum CVSS score.';

export const SHOW_ALL_MODULES_OPTION = 'SHOW_ALL_MODULES_OPTION';

export const SHOW_ALL_BUGS_OPTION = 'SHOW_ALL_BUGS_OPTION';

export const SHOW_HEATMAP_OPTION = 'SHOW_HEATMAP_OPTION';